import XDate from 'xdate';
import {getTimeSinceUTCDate} from '~/common/timestamp';
import {Typography} from '~library/atoms/Typography';

function insertAt(position, val, str) {
  return str.substr(0, position) + val + str.substr(position);
}

// Not a real iso checker, but checks for our purposes
function isIsoDate(str) {
  return /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z/.test(str);
}

function formatTimestamp(ts) {
  /*  Timestamps from the api aren't valid ISO so we need to format them.
      They look like this: 20161219T205151
      They need to look like this: 2016-12-19T20:51:51Z */

  let timestamp = insertAt(15, 'Z', ts);
  timestamp = insertAt(13, ':', timestamp);
  timestamp = insertAt(11, ':', timestamp);
  timestamp = insertAt(6, '-', timestamp);
  timestamp = insertAt(4, '-', timestamp);

  return timestamp;
}

export function getTimeSince(ts) {
  const timestamp = isIsoDate(ts) ? ts : formatTimestamp(ts);
  const utcTimestamp = XDate(timestamp);
  return getTimeSinceUTCDate(utcTimestamp);
}

export const TimeSince = (props) => {
  const {timestamp, dataQaId, inline} = props;
  return (
    <Typography inline={inline} data-qa-id={dataQaId || ''} variant="paragraph4">
      {getTimeSince(timestamp)}
    </Typography>
  );
};
